/**
 * Which kind of device this is, as far as either side needs to know.
 *
 * Both ask: the scanner sizes its capture and its energy policy by it, the view chooses
 * an install guide and a layout by it. Neither should sniff the user agent twice with
 * two slightly different regexes, which is how the two answers drift apart.
 */

/** iPadOS identifies as macOS, so touch-capable MacIntel belongs with iPhone and iPad. */
export function isIos(): boolean {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

export function isAndroid(): boolean {
  return /Android/i.test(navigator.userAgent);
}

/** Coarse primary pointer catches Android tablets whose UA omits the word Mobile. */
export function isMobile(): boolean {
  return (
    isIos() ||
    /Android|Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (navigator.maxTouchPoints > 0 && matchMedia("(pointer: coarse)").matches)
  );
}
